module.exports = __webpack_public_path__ + "static/img/1.233814f.png";


//////////////////
// WEBPACK FOOTER
// ./static/pc/1.png
// module id = imOX
// module chunks = 0